
require('with-global-jquery')(function () {
	require('bootstrap-touchspin');
});

